import { B2BOrganization } from 'types/b2b-organization';

export type B2BOrganizationEvents = {
  'b2b_organization/FETCH_LIST/init': undefined;
  'b2b_organization/FETCH_LIST/request': undefined;
  'b2b_organization/FETCH_LIST/success': B2BOrganization[];
  'b2b_organization/FETCH_LIST/failure': Error;
  'b2b_organization/CURRENT_ORGANIZATION_NUMBER/set': string;
};

export const B2B_ORGANIZATION_ACTIONS = {
  init: 'b2b_organization/FETCH_LIST/init',
  request: 'b2b_organization/FETCH_LIST/request',
  success: 'b2b_organization/FETCH_LIST/success',
  failure: 'b2b_organization/FETCH_LIST/failure',
  setCurrentOrganizationNumber: 'b2b_organization/CURRENT_ORGANIZATION_NUMBER/set',
} as const;
